import { CalendarDaysIcon } from '@heroicons/react/20/solid'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { buildGoogleCalendarUrl } from './buildTrainingIcs'

const buttonClassName = 'inline-flex items-center justify-center gap-2 rounded-md border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60'

export default function AddToCalendarButton({ training, className = buttonClassName }) {
	const { t } = useTranslation()
	const href = useMemo(() => buildGoogleCalendarUrl(training), [training])
	const label = (
		<>
			<CalendarDaysIcon className="size-4" aria-hidden="true" />
			{t('trainings.details.actions.addToCalendar')}
		</>
	)

	if (!href) {
		return (
			<button type="button" disabled className={className}>
				{label}
			</button>
		)
	}

	return (
		<a href={href} target="_blank" rel="noopener noreferrer" className={className}>
			{label}
		</a>
	)
}
